import React from 'react';

function AuthorizedTransaction() {
  return (
    <svg width='32' height='32' fill='none' viewBox='0 0 32 32'>
      <rect width='32' height='32' fill='#E6F7FF' rx='8'></rect>
      <path
        fill='#1890FF'
        stroke='#1890FF'
        strokeWidth='0.1'
        d='M22.5 13.05h.05v-1.6H9.45V20.55h2.8c.2 0 .365.067.5.2a.67.67 0 01.2.496.684.684 0 01-.201.5.67.67 0 01-.499.204H9.5a1.507 1.507 0 01-1.018-.434 1.34 1.34 0 01-.432-1.01V11.5c0-.389.144-.727.433-1.017A1.39 1.39 0 019.5 10.05h13c.389 0 .727.143 1.017.433.29.29.433.628.433 1.017v4.45H9.55v-2.9H22.5zm-4.202 8.86l.035.036.036-.036 4.083-4.083a.632.632 0 01.484-.204c.18.006.345.08.497.225a.695.695 0 01-.01.992l-4.583 4.583h0a.68.68 0 01-.992 0l-2.48-2.48a.668.668 0 01-.214-.485c0-.18.07-.34.215-.485a.683.683 0 01.99 0h.001l1.938 1.937z'></path>
    </svg>
  );
}

export default AuthorizedTransaction;
